import asyncActionTypes from '../actions/types';

const initialState = {
  activate: false,
  isSuccess: false,
};

const activeBannerUpdateConsent = (state = initialState, action) => {
  if (action.type === asyncActionTypes.ACTIVE_BANNER) {
    return {
      ...state,
      activate: action.activate,
      isSuccess: action.isSuccess,
    };
  } else {
    return state;
  }
};

export default activeBannerUpdateConsent;